import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'mp-zendesk-help-center-button',
  templateUrl: './zendesk-help-center-button.component.html',
  styleUrl: './zendesk-help-center-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButton, MatTooltip],
})
export class ZendeskHelpCenterButtonComponent {
  readonly isSmall: InputSignal<boolean> = input.required<boolean>();

  readonly openZendeskHelpCenterInfoFlyoutClick: OutputEmitterRef<void> = output<void>();

  openZendeskHelpCenterInfoFlyout(): void {
    this.openZendeskHelpCenterInfoFlyoutClick.emit();
  }
}
